var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_2419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7701 6H8.5V7.64881H13.7704L8.52803 10.8626V19.1625H9.98581V15.0265L15.3123 19.1346H16.7981V18.2962V18.1564V11.1141H11.2754L16.7981 7.59291V6H16.7701ZM15.2562 12.707L15.2843 16.9548L9.95777 12.707H15.2562Z",
    fill: "url(#paint0_linear_1101_2419)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_2419",
    x1: 7.84273,
    y1: 3.12647,
    x2: 17.1012,
    y2: 3.22667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_2419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZts);
export default __webpack_public_path__ + "static/media/zts.ede14e56ebbbf9bb154192c76ccc4b9a.svg";
export { ForwardRef as ReactComponent };